export class ErrorType {
    public static BadRequest = 400;
    public static Unauthorized = 401;
    public static InternalServerError = 500;
    public static UnexpectedErrorMessage = 'Unexpected Error';

    public static _4001: ErrorType = { code: 4001, message: 'invalid session' };
    public static _4002: ErrorType = { code: 4002, message: 'required  parameter is missing' };
    public static _4101: ErrorType = { code: 4101, message: 'Invalid User' };
    public static _4201: ErrorType = { code: 4201, message: 'Invalid token' };
    public static _4202: ErrorType = { code: 4202, message: 'Invalid captcha' };
    public static _4301: ErrorType = { code: 4301, message: 'Invalid email' };
    public static _4401: ErrorType = { code: 4401, message: 'Invalid password length' };
    public static _4402: ErrorType = { code: 4402, message: 'Invalid password, capitals letters required' };
    public static _4403: ErrorType = { code: 4403, message: 'Invalid password, mandatory lowercase' };
    public static _4404: ErrorType = { code: 4404, message: 'Invalid password, number(s) required' };
    public static _4405: ErrorType = { code: 4405, message: 'Password cannot contain login, firstname or lastname' };
    public static _4406: ErrorType = { code: 4406, message: 'Password not comply history' };
    public static _4407: ErrorType = { code: 4407, message: 'Invalid password, ASCII required' };
    public static _4408: ErrorType = { code: 4408, message: 'Confirm password not equal' };
    public static _5001: ErrorType = { code: 5001, message: 'Unexpected error' };
    public static _5101: ErrorType = { code: 5101, message: 'Could not validate user' };
    public static _5102: ErrorType = { code: 5102, message: 'Duplicate mail user' };
    public static _5201: ErrorType = { code: 5201, message: 'Could not validate token' };
    public static _5202: ErrorType = { code: 5202, message: 'Could not generate token' };
    public static _5301: ErrorType = { code: 5301, message: 'Could not validate email' };
    public static _5302: ErrorType = { code: 5302, message: 'Could not change email' };
    public static _5303: ErrorType = { code: 5303, message: 'Could not send email' };
    public static _5401: ErrorType = { code: 5401, message: 'Could not validate password' };
    public static _5402: ErrorType = { code: 5402, message: 'Could not change password' };

    code: number;
    message: string;

    constructor(code: number, message: string) {
      this.code = code;
      this.message = message;
    }
}
